import React from 'react'
import { IKImage } from 'imagekitio-react'

const S3_URL = process.env.REACT_APP_BACKEND_S3_BASE_URL;
const USE_IMAGE_KIT = process.env.REACT_APP_USE_IMAGEKIT === '1';

const Image = ({ src, alt = "image", className, lazyLoad = true, useImageKit = true }) => {  
  const getImageSRC = () => {  
    if(USE_IMAGE_KIT && useImageKit && src.includes(S3_URL)) {
      const relativePath = src.split(S3_URL);
      return relativePath[1];
    }
    else if(USE_IMAGE_KIT && useImageKit && src.startsWith('assets/')) {
      return src;
    }
    return src;
  }

  return (
    USE_IMAGE_KIT && useImageKit ? (
      <IKImage 
        path={getImageSRC()} 
        transformation={[{
          quality: 70,
          format: 'webp',
        }]} 
        loading={lazyLoad ? "lazy" : "eager"}
        className={className}
      />
    )
    :
    (
      <img src={getImageSRC()} alt={alt} className={`object-cover ${className}`} loading={lazyLoad ? "lazy" : "eager"} />
    )
  )
}

export default Image